export interface Product {
  id: string;
  name: string;
  priceCNY: string;
  priceUSD: string;
  image: string;
  url: string;
}

export interface ProductCategory {
  id: string;
  name: string;
  categoryUrl: string;
  products: Product[];
}

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const productCategories: ProductCategory[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    categoryUrl: 'https://kaspreadsheet.com/category-911-Shoes.html',
    products: [
      {
        id: '136312',
        name: 'Black Canvas Combat Boots with Side Zippers and Lace-Up Design',
        priceCNY: '678',
        priceUSD: '94.17',
        image: 'https://si.geilicdn.com/open1775823299-1234478995-52da00000198bbc54c190aa0c791_620_620.jpg',
        url: 'https://kaspreadsheet.com/goods-136312.html',
      },
      {
        id: '136311',
        name: 'Louis Vuitton Archlight White Monogram Print Sneakers',
        priceCNY: '397',
        priceUSD: '55.14',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9600000194e2901d1a0a239383_800_600.jpg',
        url: 'https://kaspreadsheet.com/goods-136311.html',
      },
      {
        id: '136310',
        name: 'Rick Owens Geobasket High-Top Sneaker Black White Contrast Toe',
        priceCNY: '585',
        priceUSD: '81.25',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1a000000019749d603be0a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136310.html',
      },
      {
        id: '136309',
        name: 'Off-White Diagonal Arrow Low-Top Sneakers White/Black',
        priceCNY: '300',
        priceUSD: '41.67',
        image: 'https://si.geilicdn.com/pcitem1513127982-3b200000019667fbebea0a21146b_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136309.html',
      },
      {
        id: '136308',
        name: 'Nike Tiempo Legend 9 IC Indoor Court Soccer Shoes Multicolor',
        priceCNY: '268',
        priceUSD: '37.22',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9000000194b81466ec0aa08290_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136308.html',
      },
      {
        id: '136307',
        name: 'Louis Vuitton Archlight Star Motif Sneaker Beige Snake Print',
        priceCNY: '528',
        priceUSD: '73.33',
        image: 'https://si.geilicdn.com/pcitem1871933355-69ef00000190a56ff3d40a8133cc_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136307.html',
      },
      {
        id: '136306',
        name: 'Louis Vuitton Trainer Low Monogram Canvas Sneaker Red White',
        priceCNY: '297',
        priceUSD: '41.25',
        image: 'https://si.geilicdn.com/wdseller901862032983-53ff00000190603e9a530a2102c5_1170_1173.jpg',
        url: 'https://kaspreadsheet.com/goods-136306.html',
      },
      {
        id: '136305',
        name: 'Off-White Diagonal Arrow Low-Top Sneakers Black-White',
        priceCNY: '258',
        priceUSD: '35.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-38cd000001977cd8cc7d0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136305.html',
      },
    ],
  },
  {
    id: 'hoodies-sweaters',
    name: 'Hoodies/Sweaters',
    categoryUrl: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    products: [
      {
        id: '138084',
        name: 'OFFSETTEARS Black Hoodie with Orange Floral Graphic and Signature Print',
        priceCNY: '186',
        priceUSD: '25.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6bc000000194965ed7d10a239383_1920_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-138084.html',
      },
      {
        id: '137567',
        name: 'Supreme Margiela Paris 1994 Zip-Up Hoodie Skull Lining Black',
        priceCNY: '136',
        priceUSD: '18.89',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4ad900000199c30f90a50aa0229a_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-137567.html',
      },
      {
        id: '137459',
        name: 'BAPE x Inter Miami CF Camo Hoodie Pink Black Gray',
        priceCNY: '141',
        priceUSD: '19.58',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-0c480000019791690d9a0a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137459.html',
      },
      {
        id: '137449',
        name: 'Dior Oblique Monogram Logo Applique White Sweatshirt',
        priceCNY: '176',
        priceUSD: '24.44',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-679b00000195474e9a2d0a8115c2_1125_1125.jpg',
        url: 'https://kaspreadsheet.com/goods-137449.html',
      },
      {
        id: '137348',
        name: 'Nike Lost Repeat Graphic Fleece Crewneck Sweatshirt Cream Green',
        priceCNY: '274',
        priceUSD: '38.06',
        image: 'https://si.geilicdn.com/pcitem1945679661-278900000198c64832cd0a20e2c5_945_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-137348.html',
      },
      {
        id: '137303',
        name: 'BOSS Embossed Logo Crewneck Sweatshirt Black',
        priceCNY: '141',
        priceUSD: '19.58',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4dc8000001977c8963190a8133b0_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-137303.html',
      },
      {
        id: '137105',
        name: 'Polo Ralph Lauren Cable Knit Short-Sleeve Crewneck Sweater Pink',
        priceCNY: '148',
        priceUSD: '20.56',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7dfe000001955822c0a80a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137105.html',
      },
      {
        id: '137044',
        name: 'Burberry Rainbow Equestrian Knight Logo White Sweatshirt',
        priceCNY: '155',
        priceUSD: '21.53',
        image: 'https://si.geilicdn.com/pcitem1886196013-3fe800000195989eafd90a210256_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137044.html',
      },
    ],
  },
  {
    id: 't-shirts',
    name: 'T-Shirts',
    categoryUrl: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    products: [
      {
        id: '138192',
        name: 'Nike Dri-FIT Cotton T-Shirt with 1972 Logo Print Black',
        priceCNY: '112',
        priceUSD: '15.56',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-529a000001977c85cb740a231226_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138192.html',
      },
      {
        id: '138188',
        name: 'Louis Vuitton x Malletier Navy T-Shirt with White Rabbit Graphic',
        priceCNY: '175',
        priceUSD: '24.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-2e0f00000196ab5b18160a8133b0_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-138188.html',
      },
      {
        id: '138187',
        name: 'Stussy World Tour Polo Shirt White/Black with Lion & Billiard Ball',
        priceCNY: '169',
        priceUSD: '23.47',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0017000001974412c93c0a23b491_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-138187.html',
      },
      {
        id: '138186',
        name: 'FENDI Dragon Graphic T-Shirt Black',
        priceCNY: '109',
        priceUSD: '15.14',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3868000001955b71f6390a23b491_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-138186.html',
      },
      {
        id: '138185',
        name: 'Palm Angels Bear Graphic T-Shirt Black',
        priceCNY: '139',
        priceUSD: '19.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-3d10000001952f1af3560a23b491_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-138185.html',
      },
      {
        id: '138183',
        name: 'Rhude Premium Cigars Logo Graphic T-Shirt Black',
        priceCNY: '98',
        priceUSD: '13.61',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-214100000195c9825ed90a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138183.html',
      },
      {
        id: '138182',
        name: 'Valentino VLogo Embroidered Black T-Shirt with Pink Logo',
        priceCNY: '150',
        priceUSD: '20.83',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-4cd50000019648d7af310a23b491-unadjust_475_522.png',
        url: 'https://kaspreadsheet.com/goods-138182.html',
      },
      {
        id: '138181',
        name: 'Cole Buxton Dog Logo Graphic T-Shirt Black',
        priceCNY: '124',
        priceUSD: '17.22',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-096700000197974c396b0a22d249_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-138181.html',
      },
    ],
  },
  {
    id: 'jackets',
    name: 'Jackets',
    categoryUrl: 'https://kaspreadsheet.com/category-914-Jackets.html',
    products: [
      {
        id: '136582',
        name: 'Under Armour Storm Rain Jacket Black with Reflective Logo',
        priceCNY: '118',
        priceUSD: '16.39',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-69310000019715c9e1c30a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136582.html',
      },
      {
        id: '136303',
        name: 'Louis Vuitton Monogram Print Hooded Windbreaker Jacket Black',
        priceCNY: '472',
        priceUSD: '65.56',
        image: 'https://si.geilicdn.com/open1742170557-1234478995-7b50000001977caa02d80a22d249_1276_1702.jpg',
        url: 'https://kaspreadsheet.com/goods-136303.html',
      },
      {
        id: '136284',
        name: 'A BATHING APE Denim Jacket with Embroidered Cross Motif',
        priceCNY: '288',
        priceUSD: '40.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7e94000001943acc82ee0a239383_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-136284.html',
      },
      {
        id: '136276',
        name: 'Zara Butterfly Logo Fleece Track Jacket Navy Purple Stripes',
        priceCNY: '190',
        priceUSD: '26.39',
        image: 'https://si.geilicdn.com/open1675136579-1234478995-66aa00000198a68a28e10a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136276.html',
      },
      {
        id: '136203',
        name: 'Canada Goose Crofton Vest Black Quilted Down Puffer Vest',
        priceCNY: '329',
        priceUSD: '45.69',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0d9d00000194c30b210a0a210559_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136203.html',
      },
      {
        id: '136189',
        name: 'Louis Vuitton Monogram Quilted Puffer Jacket Gray Black',
        priceCNY: '260',
        priceUSD: '36.11',
        image: 'https://si.geilicdn.com/pcitem901971869584-335c00000199bdf837270a23111a_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-136189.html',
      },
      {
        id: '136181',
        name: 'Canada Goose Youth Expedition Parka Arctic Camo with Fur Trim',
        priceCNY: '590',
        priceUSD: '81.94',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4c51000001952f1d25bb0aa0834c_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136181.html',
      },
      {
        id: '135968',
        name: 'Prada RDAPA Logo Tape Track Jacket White Black',
        priceCNY: '517',
        priceUSD: '71.81',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3e840000019769c4fcd30a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135968.html',
      },
    ],
  },
  {
    id: 'pants-shorts',
    name: 'Pants/Shorts',
    categoryUrl: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    products: [
      {
        id: '137495',
        name: 'OceanView Cruise Logo Shorts Pink Cotton Blend',
        priceCNY: '94',
        priceUSD: '13.06',
        image: 'https://si.geilicdn.com/open1877254536-1234478995-1a74000001972b942b510a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-137495.html',
      },
      {
        id: '137207',
        name: 'Prada Re-Nylon Triangle Logo Swim Shorts Black',
        priceCNY: '153',
        priceUSD: '21.25',
        image: 'https://si.geilicdn.com/open1691309225-1234478995-51a700000196d91ec6a60aa0834c_2560_2560.jpg',
        url: 'https://kaspreadsheet.com/goods-137207.html',
      },
      {
        id: '136530',
        name: '1230 Holy Holy Graphic Shorts Black Mesh Side Panel',
        priceCNY: '142',
        priceUSD: '19.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1d6c00000197494076c30a22d249-unadjust_900_900.png',
        url: 'https://kaspreadsheet.com/goods-136530.html',
      },
      {
        id: '136300',
        name: 'Balenciaga Rainbow Logo Washed Light Grey Denim Jeans',
        priceCNY: '280',
        priceUSD: '38.89',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-78d400000196c048651b0a231226_1442_1922.jpg',
        url: 'https://kaspreadsheet.com/goods-136300.html',
      },
      {
        id: '136286',
        name: 'DEPT de la GALERIE Paint-Splatter Track Pants White',
        priceCNY: '169',
        priceUSD: '23.47',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-606c00000193dded32260a22d234_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136286.html',
      },
      {
        id: '136266',
        name: 'Gucci GG Monogram Print Drawstring Shorts White/Navy',
        priceCNY: '110',
        priceUSD: '15.28',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-71b10000019648fa027e0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136266.html',
      },
      {
        id: '136257',
        name: 'Nike Run Air Force 1 Black Jogger Pants with Side Logo',
        priceCNY: '120',
        priceUSD: '16.67',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-70e300000196c03ef9eb0a231226_1440_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-136257.html',
      },
      {
        id: '136249',
        name: 'Moncler Diagonal Stripe Shorts White with Red Accent',
        priceCNY: '199',
        priceUSD: '27.64',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0e490000019558486bc90a8115c2_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136249.html',
      },
    ],
  },
  {
    id: 'headwear',
    name: 'Headwear',
    categoryUrl: 'https://kaspreadsheet.com/category-916-Headwear.html',
    products: [
      {
        id: '133388',
        name: 'New Era 59FIFTY MLB Authentic On-Field Cap Black LA Dodgers Palm Tree',
        priceCNY: '170',
        priceUSD: '23.61',
        image: 'https://si.geilicdn.com/open1821611651-1234478995-7ca3000001984ac153c70aa043f9_1137_1137.jpg',
        url: 'https://kaspreadsheet.com/goods-133388.html',
      },
      {
        id: '133383',
        name: 'Burberry Logo Knit Beanie Hat Gray with Black Band',
        priceCNY: '112',
        priceUSD: '15.56',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-73f50000019767422ae30a22d249_1074_1074.jpg',
        url: 'https://kaspreadsheet.com/goods-133383.html',
      },
      {
        id: '133370',
        name: 'alo Reflective Visor with Embossed Logo Black Silver',
        priceCNY: '81',
        priceUSD: '11.25',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-31420000019672781d5b0a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133370.html',
      },
      {
        id: '133369',
        name: 'Gucci GG Monogram Beige Mesh Baseball Cap with Brown Trim',
        priceCNY: '110',
        priceUSD: '15.28',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-544b0000019764bb73ad0aa0c79f-unadjust_886_849.png',
        url: 'https://kaspreadsheet.com/goods-133369.html',
      },
      {
        id: '133362',
        name: 'SYNER Graffiti Knit Beanie Hat Neon Green/Black Contrast',
        priceCNY: '81',
        priceUSD: '11.25',
        image: 'https://si.geilicdn.com/open1612884413-1234478995-1c6c000001977e57fb830a231226_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-133362.html',
      },
      {
        id: '133349',
        name: 'Dior Oblique Monogram Baseball Cap Black-White Pattern',
        priceCNY: '99',
        priceUSD: '13.75',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6e3400000195457be2de0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133349.html',
      },
      {
        id: '133343',
        name: 'New Era 59FIFTY MLB Los Angeles Dodgers Floral Blue Cap',
        priceCNY: '99',
        priceUSD: '13.75',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4bc600000194e27f91c20a232357-unadjust_900_900.png',
        url: 'https://kaspreadsheet.com/goods-133343.html',
      },
      {
        id: '133342',
        name: 'Stone Island Compass Logo Bucket Hat Gray with Drawstring',
        priceCNY: '58',
        priceUSD: '8.06',
        image: 'https://si.geilicdn.com/pcitem901908522262-348800000195413652c40a2395d6-unadjust_500_500.gif',
        url: 'https://kaspreadsheet.com/goods-133342.html',
      },
    ],
  },
  {
    id: 'sets',
    name: 'Sets',
    categoryUrl: 'https://kaspreadsheet.com/category-917-Sets.html',
    products: [
      {
        id: '138191',
        name: 'Nike Dri-FIT Academy Soccer Jersey and Shorts Set Black/White',
        priceCNY: '144',
        priceUSD: '20.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-15a700000197493e80b70a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138191.html',
      },
      {
        id: '138184',
        name: 'Stone Island Compass Logo Short Set White',
        priceCNY: '175',
        priceUSD: '24.31',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-22160000019769f3aee70aa0c79f_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138184.html',
      },
      {
        id: '138178',
        name: 'Gucci GG Monogram Print Short-Sleeve Shirt and Shorts Set Beige',
        priceCNY: '154',
        priceUSD: '21.39',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44260000019779312b2c0aa0c79f_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138178.html',
      },
      {
        id: '138161',
        name: 'Real Madrid 2023-24 Training Kit Navy Yellow V-Neck Jersey Shorts Set',
        priceCNY: '139',
        priceUSD: '19.31',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0675000001973f6663200a23b4de_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138161.html',
      },
      {
        id: '138159',
        name: 'BOSS Black Track Suit with Beige Logo Stripes and Zipper Front',
        priceCNY: '177',
        priceUSD: '24.58',
        image: 'https://si.geilicdn.com/pcitem1944626857-760e0000019773c369f50a239846_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138159.html',
      },
      {
        id: '138154',
        name: 'ALLSTAR Flame Graphic T-Shirt and Shorts Set Black with Neon Green Flames',
        priceCNY: '315',
        priceUSD: '43.75',
        image: 'https://si.geilicdn.com/open1824078381-1234478995-3ab900000196a5bc0b000a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138154.html',
      },
      {
        id: '138153',
        name: 'Stone Island Compass Logo Short Set Pink Cotton Twill',
        priceCNY: '270',
        priceUSD: '37.50',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-0fa9000001973f4d55700a23b4de_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138153.html',
      },
      {
        id: '138135',
        name: 'Versace Logo Print Short-Sleeve Shirt and Shorts Set Navy Green Pink',
        priceCNY: '125',
        priceUSD: '17.36',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-53280000019572c0d6ca0a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138135.html',
      },
    ],
  },
  {
    id: 'underwear',
    name: 'underwear/underpants',
    categoryUrl: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    products: [
      {
        id: '136447',
        name: 'Louis Vuitton Monogram Gradient Bodysuit with White Trim',
        priceCNY: '159',
        priceUSD: '22.08',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-416b0000019572963ee90aa08290_1440_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-136447.html',
      },
      {
        id: '136200',
        name: 'lululemon Align Soft High-Waisted Underwear with Lace Trim',
        priceCNY: '95',
        priceUSD: '13.19',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-3e8000000197a64cbaec0a23b491_1080_1441.jpg',
        url: 'https://kaspreadsheet.com/goods-136200.html',
      },
      {
        id: '136037',
        name: 'Calvin Klein Men\'s Cotton Boxer Briefs Gray Black Navy',
        priceCNY: '29',
        priceUSD: '4.03',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-417800000193c49caaea0a210559_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136037.html',
      },
      {
        id: '135612',
        name: 'LACOSTE Classic Logo Waistband Boxer Briefs 3-Pack Green White Black',
        priceCNY: '99',
        priceUSD: '13.75',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-659b00000193ce9623d00a8133b5_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135612.html',
      },
      {
        id: '135596',
        name: 'PSD SpongeBob SquarePants Underwear Blue Ocean Print Boxer Briefs',
        priceCNY: '45',
        priceUSD: '6.25',
        image: 'https://si.geilicdn.com/pcitem901950853318-589000000196dd1ae0cf0a81347d_4800_4800.jpg',
        url: 'https://kaspreadsheet.com/goods-135596.html',
      },
      {
        id: '135593',
        name: 'Calvin Klein Men\'s Cotton Boxer Briefs Gray Black Navy',
        priceCNY: '108',
        priceUSD: '15.00',
        image: 'https://si.geilicdn.com/open1783746229-1234478995-7eae000001966daf5aca0a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-135593.html',
      },
      {
        id: '135575',
        name: 'Supreme Boxer Briefs Cotton Underwear with Logo Waistband',
        priceCNY: '30',
        priceUSD: '4.17',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7ffd000001974a632f450a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135575.html',
      },
      {
        id: '135566',
        name: 'Hermes Logo Waistband Boxer Briefs Black White Yellow',
        priceCNY: '34',
        priceUSD: '4.72',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-2360000001977d2fc4a40a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135566.html',
      },
    ],
  },
  {
    id: 'jersey',
    name: 'Jersey',
    categoryUrl: 'https://kaspreadsheet.com/category-919-Jersey.html',
    products: [
      {
        id: '138190',
        name: 'Paris Saint-Germain 2023 Champions of Europe Jersey Navy Blue',
        priceCNY: '106',
        priceUSD: '14.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-030c000001973f6540060aa0834c_942_983.jpg',
        url: 'https://kaspreadsheet.com/goods-138190.html',
      },
      {
        id: '138180',
        name: 'PSG Qatar Airways Training Jersey Red Blue Abstract Pattern',
        priceCNY: '165',
        priceUSD: '22.92',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7a2000000195bfc0adac0a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138180.html',
      },
      {
        id: '138175',
        name: 'FC Barcelona Lamine Yamal 19 Black Away Jersey 2024-25',
        priceCNY: '128',
        priceUSD: '17.78',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-025700000195cf19315b0a23b4de_450_450.jpg',
        url: 'https://kaspreadsheet.com/goods-138175.html',
      },
      {
        id: '138164',
        name: 'Supreme 30th Anniversary Football Jersey Green Diamond Pattern',
        priceCNY: '331',
        priceUSD: '45.97',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1c2d000001974942961f0a23b4de_800_762.jpg',
        url: 'https://kaspreadsheet.com/goods-138164.html',
      },
      {
        id: '138155',
        name: 'Palmeiras 2023 Home Jersey Yellow Green Crest',
        priceCNY: '63',
        priceUSD: '8.75',
        image: 'https://si.geilicdn.com/open1675274933-1234478995-19cc000001967ca93aab0a23b491_1202_1202.jpg',
        url: 'https://kaspreadsheet.com/goods-138155.html',
      },
      {
        id: '138150',
        name: 'Real Madrid 2000-01 Home Jersey White with Black Stripes TeKa Sponsor',
        priceCNY: '118',
        priceUSD: '16.39',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-66a800000195bfccb6a40a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138150.html',
      },
      {
        id: '138148',
        name: 'Adidas x Flame Silhouette Football Jersey White Black Design',
        priceCNY: '99',
        priceUSD: '13.75',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-279000000195c9a5168f0aa08290_941_963.jpg',
        url: 'https://kaspreadsheet.com/goods-138148.html',
      },
      {
        id: '138139',
        name: 'PSG 2023-24 Third Jersey Black with Red-White-Blue Vertical Stripes',
        priceCNY: '142',
        priceUSD: '19.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7bf5000001975f2f34a10a23b4de_1107_1107.jpg',
        url: 'https://kaspreadsheet.com/goods-138139.html',
      },
    ],
  },
  {
    id: 'accessories',
    name: 'Accessories',
    categoryUrl: 'https://kaspreadsheet.com/category-920-Accessories.html',
    products: [
      {
        id: '137556',
        name: 'Cartier Santos Dumont Square Watch Blue Dial Black Leather Strap',
        priceCNY: '599',
        priceUSD: '83.19',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-10690000019673cee0e70aa0834c_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137556.html',
      },
      {
        id: '137382',
        name: 'Louis Vuitton Monogram World Tour Bracelet Black Rope with Logo Discs',
        priceCNY: '165',
        priceUSD: '22.92',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-423700000197160db1620a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137382.html',
      },
      {
        id: '135965',
        name: 'Apple Watch Series 6 Black Aluminum Case with Black Sport Band',
        priceCNY: '170',
        priceUSD: '23.61',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-5ea900000193d8cce9290a232357_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-135965.html',
      },
      {
        id: '135384',
        name: 'Apple Watch Series 9 GPS + Cellular Black Aluminum Case with Black Sport Band',
        priceCNY: '288',
        priceUSD: '40.00',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-07640000019673be92750a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135384.html',
      },
      {
        id: '135380',
        name: 'Apple Watch Ultra 2 with Purple Woven Band GPS + Cellular',
        priceCNY: '399',
        priceUSD: '55.42',
        image: 'https://si.geilicdn.com/open1776978413-1234478995-0d200000019740bb8f220a8115c2_1179_1179.jpg',
        url: 'https://kaspreadsheet.com/goods-135380.html',
      },
      {
        id: '134538',
        name: 'Apple Watch Ultra 2 with Desert Tan Alpine Loop Band',
        priceCNY: '275',
        priceUSD: '38.19',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3047000001927ca712ba0aa08290_1290_1290.jpg',
        url: 'https://kaspreadsheet.com/goods-134538.html',
      },
      {
        id: '133945',
        name: 'Casio Baby-G G-Lide BGA-210 Digital Watch Neon Green Resin Case',
        priceCNY: '150',
        priceUSD: '20.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4a5a000001937c768dab0a210298_1080_810.jpg',
        url: 'https://kaspreadsheet.com/goods-133945.html',
      },
      {
        id: '133944',
        name: 'Apple Watch Series 7 Black Aluminum with Midnight Sport Band',
        priceCNY: '258',
        priceUSD: '35.83',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0fe50000019673cd17830aa0834c_750_750.jpg',
        url: 'https://kaspreadsheet.com/goods-133944.html',
      },
    ],
  },
  {
    id: 'bags',
    name: 'Bags',
    categoryUrl: 'https://kaspreadsheet.com/category-921-Bags.html',
    products: [
      {
        id: '135418',
        name: 'SMINDUS TRUO Black Mesh Golf Towel with Pink Logo and Globe Design',
        priceCNY: '261',
        priceUSD: '36.25',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44f8000001976cf1b5d50a8115c2-unadjust_500_500.gif',
        url: 'https://kaspreadsheet.com/goods-135418.html',
      },
      {
        id: '134959',
        name: 'Prada Milano Woven Mini Tote Bag Black Textured with Logo',
        priceCNY: '335',
        priceUSD: '46.53',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-5c300000019572da6a310a8115c2_1442_1922.jpg',
        url: 'https://kaspreadsheet.com/goods-134959.html',
      },
      {
        id: '133386',
        name: 'Goyard Saint Louis Mini Crossbody Bag Pink Chevron Pattern',
        priceCNY: '165',
        priceUSD: '22.92',
        image: 'https://si.geilicdn.com/pcitem901900035971-74aa000001938a89828e0a23041a_1000_1333.jpg',
        url: 'https://kaspreadsheet.com/goods-133386.html',
      },
      {
        id: '133276',
        name: 'Louis Vuitton Monogram Canvas Tote Bag Brown with Tan Leather Trim',
        priceCNY: '139',
        priceUSD: '19.31',
        image: 'https://si.geilicdn.com/pcitem901891552790-1ba50000019390628c620a2396f4_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133276.html',
      },
      {
        id: '133272',
        name: 'Chanel 25P Kelly Mini Bag Beige Quilted Lambskin Top Handle Chain',
        priceCNY: '374',
        priceUSD: '51.94',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-534900000195a49cb72e0a8133b0_1080_1439.jpg',
        url: 'https://kaspreadsheet.com/goods-133272.html',
      },
      {
        id: '133264',
        name: 'Chanel White Quilted Double Flap Bucket Bag with Gold CC Logo',
        priceCNY: '199',
        priceUSD: '27.64',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-74c600000195475287920a23b4de_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133264.html',
      },
      {
        id: '133244',
        name: 'Goyard Saint-Louis PM Tote Bag in Green Chevron Canvas',
        priceCNY: '138',
        priceUSD: '19.17',
        image: 'https://si.geilicdn.com/open1757144309-1234478995-5bcc0000019698dce2c40a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133244.html',
      },
      {
        id: '133226',
        name: 'Louis Vuitton Allin BB Monogram Empreinte Black Bucket Bag',
        priceCNY: '546',
        priceUSD: '75.83',
        image: 'https://si.geilicdn.com/ch1931865500-1a9400000197741d80650a230115_1920_1440.jpg',
        url: 'https://kaspreadsheet.com/goods-133226.html',
      },
    ],
  },
  {
    id: 'belts',
    name: 'Belts',
    categoryUrl: 'https://kaspreadsheet.com/category-922-Belts.html',
    products: [
      {
        id: '133199',
        name: 'Fendi FF Logo Belt with Gold Silver Yellow Blue Buckle',
        priceCNY: '146',
        priceUSD: '20.28',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1bb200000197910d6d570a22d249_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-133199.html',
      },
      {
        id: '133145',
        name: 'AMIRI Logo Buckle Belt White Leather with Gold Hardware',
        priceCNY: '95',
        priceUSD: '13.19',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-482a000001952f0b7ef60aa0834c-unadjust_936_925.png',
        url: 'https://kaspreadsheet.com/goods-133145.html',
      },
      {
        id: '133079',
        name: 'Hermes H-Pin Buckle Leather Belt Multi-Color Distressed Finish',
        priceCNY: '142',
        priceUSD: '19.72',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-400500000195c492a20b0a23b4de_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133079.html',
      },
      {
        id: '133074',
        name: 'Dior Oblique Pattern Belt with CD Buckle Gray Black Silver Gold',
        priceCNY: '128',
        priceUSD: '17.78',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0eb600000194e1e8290b0a232357_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133074.html',
      },
      {
        id: '133059',
        name: 'Valentino Garavani VLogo Belt in Multiple Colors',
        priceCNY: '68',
        priceUSD: '9.44',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-07e4000001977db6177b0a8133b0_2560_3413.jpg',
        url: 'https://kaspreadsheet.com/goods-133059.html',
      },
      {
        id: '133045',
        name: 'Burberry Black Check-Print Leather Belt with Monogram Buckle',
        priceCNY: '85',
        priceUSD: '11.81',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3d6100000193b49f9e400a210298_1276_1702.jpg',
        url: 'https://kaspreadsheet.com/goods-133045.html',
      },
      {
        id: '133023',
        name: 'Fendi FF Logo Belt Black Leather with Gold Silver Black Buckles',
        priceCNY: '139',
        priceUSD: '19.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-191100000195c48b97cd0a231226-unadjust_500_375.gif',
        url: 'https://kaspreadsheet.com/goods-133023.html',
      },
      {
        id: '133021',
        name: 'Cartelostyle Geometric Pattern Leather Belt with G-Shape Buckle',
        priceCNY: '76',
        priceUSD: '10.56',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-58e500000193d93330f30a210559-unadjust_783_842.png',
        url: 'https://kaspreadsheet.com/goods-133021.html',
      },
    ],
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    categoryUrl: 'https://kaspreadsheet.com/category-923-Perfumes.html',
    products: [
      {
        id: '138044',
        name: 'Delina 75ml Pink Perfume Bottle with Tassel Cap and Elegant Design',
        priceCNY: '148',
        priceUSD: '20.56',
        image: 'https://si.geilicdn.com/pcitem1945403796-045400000196c304bc950a239846_1199_1199.jpg',
        url: 'https://kaspreadsheet.com/goods-138044.html',
      },
      {
        id: '133255',
        name: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
        priceCNY: '130',
        priceUSD: '18.06',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133255.html',
      },
      {
        id: '133248',
        name: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
        priceCNY: '109',
        priceUSD: '15.14',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-121600000194c3615f810a22d234_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133248.html',
      },
      {
        id: '133247',
        name: 'Yves Saint Laurent La Nuit de L\'Homme Eau de Parfum Black Bottle',
        priceCNY: '108',
        priceUSD: '15.00',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-03e300000197841b99f20a231226_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133247.html',
      },
      {
        id: '133207',
        name: 'Chanel Chance Eau Tendre Perfume Pink Bottle with Gold Cap',
        priceCNY: '108',
        priceUSD: '15.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0ef200000194882a14e00a232357_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133207.html',
      },
      {
        id: '133204',
        name: 'Harrods The Exclusive Collection Perfume 100ml Gold Bottle',
        priceCNY: '159',
        priceUSD: '22.08',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6a8d00000196f49bdc7b0a231226_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-133204.html',
      },
      {
        id: '133051',
        name: 'MCM Visetos Mini Bag Perfume Style Gold Logo Print',
        priceCNY: '324',
        priceUSD: '45.00',
        image: 'https://si.geilicdn.com/pcitem1968774131-48c200000197ede4c4dd0a23037f_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-133051.html',
      },
      {
        id: '133038',
        name: 'Gucci Bloom Floral Print Mini Perfume 5-Piece Gift Set',
        priceCNY: '141',
        priceUSD: '19.58',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133038.html',
      },
    ],
  },
];